/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_SelectionInputs */

const en_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event selection`)
};

const fr_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection d’événement`)
};

const de_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsauswahl`)
};

const it_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione dell'evento`)
};

const ru_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор мероприятия`)
};

const es_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de eventos`)
};

const zh_cn2_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件选择`)
};

const ja_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの選択`)
};

const hi_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट चयन`)
};

const pt_pt2_event_selection = /** @type {(inputs: Event_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de eventos`)
};

/**
* | output |
* | --- |
* | "Event selection" |
*
* @param {Event_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_selection = /** @type {((inputs?: Event_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_selection(inputs)
	if (locale === "de") return de_event_selection(inputs)
	if (locale === "it") return it_event_selection(inputs)
	if (locale === "ru") return ru_event_selection(inputs)
	if (locale === "es") return es_event_selection(inputs)
	if (locale === "zh-CN") return zh_cn2_event_selection(inputs)
	if (locale === "ja") return ja_event_selection(inputs)
	if (locale === "hi") return hi_event_selection(inputs)
	if (locale === "pt-PT") return pt_pt2_event_selection(inputs)
	return en_event_selection(inputs)
});